package org.koin.ksp.generated

import org.koin.core.module.Module
import org.koin.dsl.*


public val com_essntl_features_crm_data_di_CRMModule : Module get() = module {
	single() { _ -> com.essntl.features.crm.data.repository.CRMRepositoryImpl(supabase=get()) } bind(com.essntl.features.crm.domain.repository.CRMRepository::class)
}
public val com.essntl.features.crm.data.di.CRMModule.module : org.koin.core.module.Module get() = com_essntl_features_crm_data_di_CRMModule
